import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "@material-tailwind/react";
import PropTypes from "prop-types";
// src/components/inputs/MapInput.js
import React from "react";

const MapInput = ({ label, value, onChange }) => {
  const handleUpdate = (index, field, newValue) => {
    const updated = [...value];
    updated[index] = { ...updated[index], [field]: newValue };
    onChange(updated);
  };

  const handleAdd = () => {
    onChange([...value, { key: "", value: "" }]);
  };

  const handleRemove = (index) => {
    const updated = value.filter((_, i) => i !== index);
    onChange(updated);
  };

  return (
    <div className="mb-4">
      <div className="mb-2 font-medium text-sm text-gray-700">{label}</div>
      {value.map((pair, index) => (
        <div key={index} className="flex items-center gap-2 mb-2">
          <Input
            label="Key"
            value={pair.key}
            onChange={(e) => handleUpdate(index, "key", e.target.value)}
            className="flex-1"
          />
          <Input
            label="Value"
            value={pair.value}
            onChange={(e) => handleUpdate(index, "value", e.target.value)}
            className="flex-1"
          />
          <button
            onClick={() => handleRemove(index)}
            className="text-red-500 hover:text-red-700"
            type="button"
            title="Remove pair"
          >
            <FontAwesomeIcon icon={faMinus} className="h-5 w-5" />
          </button>
        </div>
      ))}
      <button
        onClick={handleAdd}
        className="text-blue-600 hover:text-blue-800 mt-2 flex items-center gap-1"
        type="button"
        title="Add new pair"
      >
        <FontAwesomeIcon icon={faPlus} className="h-5 w-5" />
        Add pair
      </button>
    </div>
  );
};

MapInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  onChange: PropTypes.func.isRequired,
};

MapInput.defaultProps = {
  value: [],
};

export default MapInput;
